"use client";
import { useMemo } from "react";
import CustomView from "../custom-view";
import { SlotContainer } from "./slot-container";
import { SlotVisitProps } from "./types";

// SlotVisit Component
export function SlotVisit({
	onChange,
	unitId,
	onClick,
	userId,
	selectCallback,
	projectId,
	prefill,
	counterSlots,
	locality,
	viewCounts,
	className,
	...props
}: SlotVisitProps & { className?: string }) {
	const { views } = useMemo(() => ({ views: { customWeek: CustomView } }), []);

	return (
		<SlotContainer
			locality={locality}
			onChange={onChange}
			onClick={onClick}
			prefill={prefill}
			counterSlots={counterSlots}
			projectId={projectId}
			selectCallback={selectCallback}
			unitId={unitId || ""}
			userId={userId}
			viewCounts={viewCounts}
			views={views}
			defaultView="customWeek"
			className={className}
			{...props}
		/>
	);
}
